define('Store.Item.StockByStore', [
    'Profile.Model',
    'Store.Item.Stock.Helper',
    'underscore',
    'Utils',
    'SC.Configuration'
], function ItemKeyMappingThumbnail(
    Profile,
    Helper,
    _,
    Utils,
    Configuration
) {
    'use strict';

    Configuration.itemKeyMapping = Configuration.itemKeyMapping || {};
    _.extend(Configuration.itemKeyMapping, {
        _outOfStockMessage: function _outOfStockMessage(item) {
            var finalStore = item.get('store') || Profile.getInstance().get('store');
            if (!finalStore) {
                console.error('COULDN\'t find store');
            }
            // eslint-disable-next-line no-underscore-dangle
            return Helper._outOfStockMessage(item, finalStore);
        },
        _notSoldInStoreMessage: function _notSoldInStoreMessage(item) {
            var finalStore = item.get('store') || Profile.getInstance().get('store');
            if (!finalStore) {
                console.error('COULDN\'t find store');
            }
            // eslint-disable-next-line no-underscore-dangle
            return Helper._notSoldInStoreMessage(item, finalStore);
        },
        _soldInStore: function _soldInStore(item) {
            var finalStore = item.get('store') || Profile.getInstance().get('store');
            if (!finalStore) {
                console.error('COULDN\'t find store');
            }
            // eslint-disable-next-line no-underscore-dangle
            return Helper._soldInStore(item, finalStore);
        },
        _hideFromWebstore: function _hideFromWebstore(item) {
            var finalStore = item.get('store') || Profile.getInstance().get('store');
            if (!finalStore) {
                console.error('COULDN\'t find store');
            }
            // eslint-disable-next-line no-underscore-dangle
            return Helper._hideFromWebstore(item, finalStore);
        },
        _isPurchasable: function _isPurchasable(item) {
            var finalStore = item.get('store') || Profile.getInstance().get('store');
            if (!finalStore) {
                console.error('COULDN\'t find store');
            }
            // eslint-disable-next-line no-underscore-dangle
            return Helper._isPurchasable(item, finalStore);
        },
        _stock: function _stock(item) {
            var finalStore = item.get('store') || Profile.getInstance().get('store');
            if (!finalStore) {
                console.error('COULDN\'t find store');
            }
            // eslint-disable-next-line no-underscore-dangle
            return Helper._stock(item, finalStore);
        },
        _isInStock: function _isInStock(item) {
            var finalStore = item.get('store') || Profile.getInstance().get('store');
            if (!finalStore) {
                console.error('COULDN\'t find store');
            }
            // eslint-disable-next-line no-underscore-dangle
            return Helper._isInStock(item, finalStore);
        },
        _showOutOfStockMessage: function _showOutOfStockMessage(item) {
            var finalStore = item.get('store') || Profile.getInstance().get('store');
            if (!finalStore) {
                console.error('COULDN\'t find store');
            }
            // eslint-disable-next-line no-underscore-dangle
            return Helper._showOutOfStockMessage(item, finalStore);
        }
    });
});
